import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import IntegrationInstructionsRoundedIcon from '@mui/icons-material/IntegrationInstructionsRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import CurrencyBitcoinRoundedIcon from '@mui/icons-material/CurrencyBitcoinRounded';
import NetworkCheckRoundedIcon from '@mui/icons-material/NetworkCheckRounded';
import HowToVoteRoundedIcon from '@mui/icons-material/HowToVoteRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon />,
    title: 'Autonomous Intelligence',
    description:
      'Viva is not just a tool—it is your partner in execution. From generating ideas to delivering complete end-to-end solutions, Viva AI redefines efficiency.',
  },
  {
    icon: <CampaignRoundedIcon />,
    title: 'Autonomous Marketing',
    description:
      'Let Viva AI handle your marketing campaigns across multiple platforms. From X to Reddit, Medium to LinkedIn, schedule and automate your content distribution for maximum reach and engagement.',
  },
  {
    icon: <CurrencyBitcoinRoundedIcon />,
    title: 'Blockchain Intelligence',
    description:
      'Simplify blockchain and crypto activities. Whether it is creating smart contracts, launching tokens, analyzing portfolios, or automating trading strategies, Viva AI brings advanced blockchain intelligence to your fingertips.',
  },
  {
    icon: <ScheduleRoundedIcon />,
    title: 'Effortless Task Scheduling',
    description:
      'Let Viva AI take over your planning. Schedule tasks for any time or set up recurring workflows, and Viva AI will handle execution from start to finish.',
  },
  {
    icon: <NotificationsActiveRoundedIcon />,
    title: 'Real-Time Updates',
    description:
      'Always stay informed. Viva AI keeps you updated on the tasks through notifications, messages, or even calls. Never miss a status update, no matter where you are.',
  },
  {
    icon: <IntegrationInstructionsRoundedIcon />,
    title: 'Seamless Integrations',
    description:
      'Seamlessly connect with your favorite tools and services. Viva integrates with them and enhances productivity across tools you already use.',
  }
];

export default function Features() {
  return (
    <Box
      id="features"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        color: 'white',
        bgcolor: 'grey.900',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            Features
          </Typography>
          <Typography variant="body1" sx={{ color: 'grey.400' }}>
            Explore the features of this fully autonomous AI that does not just assist but executes.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: 'inherit',
                  p: 3,
                  height: '100%',
                  borderColor: 'hsla(220, 25%, 25%, 0.3)',
                  backgroundColor: 'grey.800',
                }}
              >
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'grey.400' }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
